import { ProfanityCheckRule } from '@/types/profanity'
import axios from './orderInstance'

// A missing policy is a valid empty state. Other failures are handled by the UI request layer.
const getProfanityCheckRule = async (): Promise<ProfanityCheckRule | null> => {
  try {
    const response = await axios.get('/profanity-check-rules/')
    return response.data
  } catch (error: any) {
    if (error?.response?.status === 404) return null
    throw error
  }
}

export default getProfanityCheckRule
